<ion-list (click)="abrirNoticia()">
  <ion-item>
    <ion-label>
      <h3>{{ config.title }}</h3>
      <p>{{ config.resume }}</p>
      <p *ngIf="config.mostrar_data == '1'">{{ getData() }}</p>
    </ion-label>

    <ion-icon slot="end" name="arrow-forward-outline" class="icon-list"></ion-icon>
  </ion-item>
</ion-list>